import { render, staticRenderFns } from "./InitVisit.vue?vue&type=template&id=54cad3c9&"
import script from "./InitVisit.vue?vue&type=script&lang=js&"
export * from "./InitVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports